<div [ngClass]="{ 'wrap-drug-name': wrapDrugName }">
  {{ candidate.drugName }}
  @if (showCopy) {
    <app-copy-to-clipboard [text]="candidate.drugName" />
  }
</div>
<div class="small">
  <strong>NDC:</strong> {{ candidate.ndc }} @if (isFlaggedForEsp) {
  <span class="flagged-for-esp p-1">ESP</span>
}
@if (showCopy) {
  <app-copy-to-clipboard [text]="candidate.ndc" />
}
@if (showHrsaRebateNdcIndicator) {
  <div>
    <span class="indicator-pill indicator-pill-green indicator-pill-full-width">
      Rebate NDC
    </span>
  </div>
}
</div>
